// extracted by mini-css-extract-plugin
export default {"svg":"iyePFUg23NJE8hd5MOHY"};